<ng-template
  let-field="field"
  let-channel="channel"
  let-viewSource="viewSource"
  let-modeView="modeView"
  let-allowScalars="allowScalars"
  let-allowDiscrete="allowDiscrete"
  let-allowContinuous="allowContinuous"
  #dragAndDrop
>
  <mode-encoding-field-single
    (update)="fieldUpdated($event)"
    (remove)="removeField($event)"
    (removeSort)="removeSort($event)"
    (getBinSize)="getBinSize($event)"
    [binSizeToFieldMap]="binSizeToFieldMap$ | async"
    [encoding]="encoding"
    [field]="field"
    [fieldFormatMap]="fieldFormatMap$ | async"
    [format]="format$ | async"
    [model]="model"
    [view]="modeView"
    [viewName]="viewSource"
    [vizToken]="vizToken$ | async"
    [chartType]="chartType$ | async"
    [allowScalars]="allowScalars"
    [allowAggregates]="true"
    [allowDiscrete]="allowDiscrete"
    [allowContinuous]="allowContinuous"
  ></mode-encoding-field-single>
</ng-template>

<div class="encoding-zone-container">
  <div class="zone margin-bottom-medium">
    <mode-encoding-dropzone
      data-test="column-dropzone"
      [header]="'Columns (X)'"
      [channel]="'column'"
      [isDraggable]="isDragging()"
      [placeholderClasses]="true"
      [fields]="columns"
      [template]="dragAndDrop"
      [viewSource]="queryToken$ | async"
      [view]="view$ | async"
      [isMetrics]="false"
      [allowDiscrete]="true"
      [allowContinuous]="false"
      [allowScalars]="true"
      [chartType]="chartTypeVegasPivotTable"
      [dragField]="dragInfo"
      (dropField)="onDrop($event)"
      (dragStart)="onDragStart($event)"
      (dragEnd)="onDragEnd($event)"
      (fieldDropOnField)="onFieldDrop($event)"
    ></mode-encoding-dropzone>
  </div>
  <div class="zone">
    <mode-encoding-dropzone
      data-test="row-dropzone"
      [header]="'Rows (Y)'"
      [channel]="'row'"
      [isDraggable]="isDragging()"
      [placeholderClasses]="true"
      [fields]="rows"
      [template]="dragAndDrop"
      [viewSource]="observables.queryToken$ | async"
      [view]="view$ | async"
      [isMetrics]="false"
      [allowDiscrete]="true"
      [allowContinuous]="false"
      [allowScalars]="true"
      [dragField]="dragInfo"
      [chartType]="chartTypeVegasPivotTable"
      (dropField)="onDrop($event)"
      (dragStart)="onDragStart($event)"
      (dragEnd)="onDragEnd($event)"
      (fieldDropOnField)="onFieldDrop($event)"
    ></mode-encoding-dropzone>
  </div>
  <div
    class="zone margin-top-medium measure-value-container"
    [class.is-showing]="hasMeasureValues"
    [class.full-height]="!isValuesEmpty()"
  >
    <mode-encoding-dropzone
      data-test="measure-values-dropzone"
      class="is-pivot"
      [header]="'Measure Values'"
      [channel]="'value'"
      [isDraggable]="isDragValidForValues"
      [placeholderClasses]="true"
      [fields]="encoding.value"
      [template]="dragAndDrop"
      [viewSource]="observables.queryToken$ | async"
      [view]="view$ | async"
      [isMetrics]="false"
      [dragField]="dragInfo"
      [namesChannel]="namesChannel"
      (dropField)="onDrop($event)"
      (dragStart)="onDragStart($event)"
      (dragEnd)="onDragEnd($event)"
      (fieldDropOnField)="onFieldDrop($event)"
      (switchNamesAxes)="onSwitchNamesAxes()"
      [isChartEncodingComplete]="isChartEncodingComplete"
      [allowDiscrete]="false"
      [allowContinuous]="true"
      [allowScalars]="false"
      [chartType]="chartTypeVegasPivotTable"
    ></mode-encoding-dropzone>
  </div>
  <div class="color-drop-zone">
    <div class="header">
      <div>Color</div>
      <div>
        <button class="color-link" (click)="addAllValuesToColor()" [disabled]="allValuesFieldInColor">Add all</button>
        <span class="divider">|</span>
        <button class="color-link" (click)="clearAllColors()" [disabled]="!fieldInColor">Clear</button>
      </div>
    </div>
    <div class="pane">
      <mode-color-channel-component
        class="channel-row"
        [channelSummary]="colorSummary"
        [encoding]="encoding"
        [model]="model"
        [view]="view"
        [renderModel]="renderModel$ | async"
        [chartService]="chartService"
        [chartType]="chartTypeVegasPivotTable"
        [queryToken]="queryToken$ | async"
        [queryRunToken]="queryRunToken$ | async"
        [vizToken]="vizToken$ | async"
        [fieldFormatMap]="fieldFormatMap$ | async"
        [fieldColorMap]="fieldColorMap$ | async"
        [format]="format$ | async"
        [isAutoOrManualRender]="isAutoOrManualRender$ | async"
        [allowContinuous]="true"
        [allowDiscrete]="true"
      ></mode-color-channel-component>
    </div>
  </div>
</div>
